import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Badge,
  Box,
  Button,
  Card,
  Checkbox,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Stack,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue
} from "@chakra-ui/react";
import { cloneDeep } from "lodash";
import { LancamentoFinanceiro } from "models/lancamento_type";
import moment from "moment";
import Pagination from "rc-pagination";
import { useEffect, useState } from "react";
import formatNumber from "views/admin/order/hooks/formatNumber";

interface IFinanceiroTable {
  add: () => void;
  list: LancamentoFinanceiro[];
  selectedList: LancamentoFinanceiro[];
  edit: (item: LancamentoFinanceiro) => void;
  deletar: (item: LancamentoFinanceiro) => void;
  showDelete: boolean;
  cancelRef: any;
  closeDelete: () => void;
  remove: () => void;
  addToList: (item: LancamentoFinanceiro) => void;
}
const FinanceiroTable = ({
  add,
  list,
  edit,
  deletar,
  cancelRef,
  closeDelete,
  remove,
  showDelete,
  addToList,
  selectedList
}: IFinanceiroTable) => {
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");

  const countPerPage = 10;
  const [value, setValue] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [collection, setCollection] = useState(
    cloneDeep(list.slice(0, countPerPage))
  );

  const updatePage = (p: number) => {
    setCurrentPage(p);
    const to = countPerPage * p;
    const from = to - countPerPage;
    setCollection(cloneDeep(list.slice(from, to)));
  };

  const findItem = (item: LancamentoFinanceiro) => {
    let retorno = false;
    const existe = selectedList.find((a) => a.id === item.id);
    if(existe) {
      retorno = true;
    }
    return retorno;
  }

  useEffect(() => {
    const updatePage = (p: number) => {
      setCurrentPage(p);
      const to = countPerPage * p;
      const from = to - countPerPage;
      setCollection(cloneDeep(list.slice(from, to)));
    };

    const searchData = (val: string) => {
      const query = val.toLowerCase();
      setCurrentPage(1);
      const data = list
        .filter(
          (item) =>
            item?.texto.toLowerCase().includes(query) ||
            item?.pessoa?.nome.toLowerCase().includes(query)
        )
        .slice(0, countPerPage);
      setCollection(data);
    };

    if (!value) {
      updatePage(1);
    } else {
      searchData(value);
    }
  }, [list, value]);


  return (
    <Card flexDirection="column" overflowX={{ sm: "scroll", lg: "hidden" }}>
      <Flex
        px="25px"
        mb="16px"
        mt="16px"
        justifyContent="space-between"
        align="center"
      >
        <Text
          color={textColor}
          fontSize="22px"
          fontWeight="700"
          lineHeight="100%"
        >
          Lançamentos Financeiros
        </Text>
          {/* <Button onClick={add} colorScheme="brand" variant="outline">
            Adicionar
          </Button> */}
      </Flex>
      <Box>
        <Stack p={4}>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="bold"
              color={textColor}
              mb="8px"
            >
              Buscar
            </FormLabel>

            <Input
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Buscar"
              fontWeight="500"
              w={320}
              size="md"
              onChange={(e) => setValue(e.target.value)}
              value={value}
            />
          </FormControl>


        </Stack>



        <Table variant="striped" color="gray.500" mb="24px" mt="12px">
          <Thead>
            <Tr>
              <Th pe="10px" borderColor={borderColor} cursor="pointer">
                <Flex
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: "10px", lg: "12px" }}
                  color="gray.400"
                >
                  #
                </Flex>
              </Th>
              <Th pe="10px" borderColor={borderColor} cursor="pointer">
                <Flex
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: "10px", lg: "12px" }}
                  color="gray.400"
                >
                  #RESPONSÁVEL
                </Flex>
              </Th>
              <Th pe="10px" borderColor={borderColor} cursor="pointer">
                <Flex
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: "10px", lg: "12px" }}
                  color="gray.400"
                >
                  #VENCIMENTO
                </Flex>
              </Th>
              <Th pe="10px" borderColor={borderColor} cursor="pointer">
                <Flex
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: "10px", lg: "12px" }}
                  color="gray.400"
                >
                  #DESCRICAO
                </Flex>
              </Th>
              <Th pe="10px" borderColor={borderColor} cursor="pointer">
                <Flex
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: "10px", lg: "12px" }}
                  color="gray.400"
                >
                  #STATUS
                </Flex>
              </Th>
              <Th pe="10px" borderColor={borderColor} cursor="pointer">
                <Flex
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: "10px", lg: "12px" }}
                  color="gray.400"
                >
                  #SITUAÇÃO
                </Flex>
              </Th>
              <Th pe="10px" borderColor={borderColor} cursor="pointer">
                <Flex
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: "10px", lg: "12px" }}
                  color="gray.400"
                >
                  #VALOR
                </Flex>
              </Th>
              {/* <Th pe="10px" borderColor={borderColor} cursor="pointer">
                <Flex
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: "10px", lg: "12px" }}
                  color="gray.400"
                >
                  #OPÇÕES
                </Flex>
              </Th> */}
            </Tr>
          </Thead>
          <Tbody>
            {collection?.map((item, index) => {
              return (
                <Tr key={`${item.id}-${item.idEmpresa}-${index}`}>
                  
                  <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                  <Checkbox
                    id={`select-$${item.id}-${item.idEmpresa}-${index}`}
                    colorScheme="brandScheme"
                    isChecked={findItem(item)}
                    onChange={(e) => {addToList(item);}}
                    me="10px"
                  />
                  </Td>
                  <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                    {item?.pessoa?.nome}
                  </Td>
                  <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                    {moment(item.vencimento).format("DD/MM/YYYY")}
                  </Td>

                  <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                    {item?.texto}
                  </Td>

                  <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                    {item?.pago === true ? (
                      <Badge backgroundColor={"green"} color={"white"}>
                        {"PAGO"}
                      </Badge>
                    ) : (
                      <Badge backgroundColor={"red"} color={"white"}>
                        {item?.texto.toLowerCase().includes("receber")
                          ? "Á RECEBER"
                          : "Á PAGAR"}
                      </Badge>
                    )}
                  </Td>

                  <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                    {moment(item?.vencimento)
                      .add({ day: 1 })
                      .isAfter(moment(new Date())) && item?.pago === false ? (
                      <Badge backgroundColor={"green"} color={"white"}>
                        {"Á VENCER"}
                      </Badge>
                    ) : (
                      <Badge backgroundColor={ item?.pago === false? "red" : "green"} color={"white"}>
                        { item?.pago === false  ? "VENCIDO" : "LIQUIDADO"}
                      </Badge>
                    )}
                  </Td>
                  <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                    {formatNumber(Number(item.valor))}
                  </Td>
                  {/* <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                    <Button
                      onClick={() => {
                        edit(item);
                      }}
                      colorScheme="green"
                      variant="ghost"
                    >
                      Editar
                    </Button>
                    <Button
                      onClick={() => {
                        deletar(item);
                      }}
                      colorScheme="red"
                      variant="ghost"
                      ml="1"
                    >
                      Excluir
                    </Button>
                  </Td> */}
                </Tr>
              );
            })}
          </Tbody>
        </Table>

        <Pagination
          pageSize={countPerPage}
          onChange={updatePage}
          current={currentPage}
          total={list.length}
            
          style={{
            float: "right",
            marginRight: 24,
            marginBottom: 24,
          }}
        />

        <AlertDialog
          isOpen={showDelete}
          leastDestructiveRef={cancelRef}
          onClose={closeDelete}
          isCentered
          motionPreset="slideInBottom"
        >
          <AlertDialogOverlay>
            <AlertDialogContent>
              <AlertDialogHeader fontSize="lg" fontWeight="bold">
                Cuidado!
              </AlertDialogHeader>

              <AlertDialogBody>
                Deseja realmente deletar esse registro?
              </AlertDialogBody>

              <AlertDialogFooter>
                <Button
                  ref={cancelRef}
                  onClick={closeDelete}
                  colorScheme={"gray"}
                >
                  Cancelar
                </Button>
                <Button ref={cancelRef} onClick={remove} colorScheme={"red"}>
                  Excluir
                </Button>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialogOverlay>
        </AlertDialog>
      </Box>
    </Card>
  );
};
export default FinanceiroTable;
